import { getToken } from '../config';
import axios from './axiosConfig';

interface ApiService {
  get: (url: string, config?: object, authRequired?: boolean) => Promise<any>;
  post: (url: string, data: any, config?: object, authRequired?: boolean) => Promise<any>;
  put: (url: string, data: any, config?: object, authRequired?: boolean) => Promise<any>;
  delete: (url: string, config?: object, authRequired?: boolean) => Promise<any>;
}

const apiService: ApiService = {
  get: async (url: string, config: object = {}, authRequired: boolean = true): Promise<any> => {
    try {
      const headers = authRequired ? { Authorization: `Bearer ${getToken()}` } : {};
      const response = await axios.get(url, { ...config, headers });
      return response.data;
    } catch (error) {
      handleError(error);
    }
  },

  post: async (url: string, data: any, config: object = {}, authRequired: boolean = true): Promise<any> => {
    try {
      const headers = authRequired ? { Authorization: `Bearer ${getToken()}` } : {};
      const response = await axios.post(url, data, { ...config, headers });
      return response.data;
    } catch (error) {
      handleError(error);
    }
  },

  put: async (url: string, data: any, config: object = {}, authRequired: boolean = true): Promise<any> => {
    try {
      const headers = authRequired ? { Authorization: `Bearer ${getToken()}` } : {};
      const response = await axios.put(url, data, { ...config, headers });
      return response.data;
    } catch (error) {
      handleError(error);
    }
  },

  delete: async (url: string, config: object = {}, authRequired: boolean = true): Promise<any> => {
    try {
      const headers = authRequired ? { Authorization: `Bearer ${getToken()}` } : {};
      const response = await axios.delete(url, { ...config, headers });
      return response.data;
    } catch (error) {
      handleError(error);
    }
  }
};

const handleError = (error: any): void => {
  console.error('API Hatası:', error);
  throw error;
};

export default apiService;